export default () => {
  parent.postMessage({ msg: 'Sis height updated', content: document.body.offsetHeight }, '*');
};
